import { InvalidDTOError } from '@/api/errors/InvalidDTOError'
import { SnapshotValueDTO } from './SnapshotValueDTO'
import { SnapshotValueRaw } from './SnapshotValueRaw'
import { TimeStepMaxDTOFactory } from './TimeStepMaxDTOFactory'
import { TimeStepMaxRaw } from './TimeStepMaxRaw'
import { TimeStepValueRaw } from './TimeStepValueRaw'
import { TimeStepValueDTOFactory } from './TimeStepValueDTOFactory'

export class SnapshotValueDTOFactory {
  static fromRaw(raw: SnapshotValueRaw): SnapshotValueDTO {
    const city = raw.city
    const timestamp = raw.timestamp
    const history = raw.history
    const reference = raw.reference
    const forecasts = raw.forecasts
    const maxFrame = raw.frame_max

    const mandatoryFields = [city, timestamp, history, reference, forecasts, maxFrame]
    if (mandatoryFields.indexOf(null) !== -1) {
      throw new InvalidDTOError(SnapshotValueDTO.name, raw)
    }
    return new SnapshotValueDTO(
      city as string,
      timestamp as string,
      history.map(TimeStepValueDTOFactory.fromRaw),
      TimeStepValueDTOFactory.fromRaw(reference as TimeStepValueRaw),
      forecasts.map(TimeStepValueDTOFactory.fromRaw),
      TimeStepMaxDTOFactory.fromRaw(maxFrame as unknown as TimeStepMaxRaw),
    )
  }
}
